import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapControlsComponent } from './field-editor-map-controls.component';
import {DxButtonGroupModule, DxToolbarModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldEditorMapControlsComponent],
  imports: [
    CommonModule,
    DxButtonGroupModule,
    DxToolbarModule
  ],
  exports: [FieldEditorMapControlsComponent]
})
export class FieldEditorMapControlsModule { }
